import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./screens/dashboard";
import Layout from "./screens/dashboardLayout";
import Track from "./screens/track/Track";
import LoginScreen from "./screens/Login/LoginScreen";
import ErrorBoundary from "./components/ErrorBoundary";

import { Provider } from "react-redux";
import store from "./redux/store";

// Toast
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularLoader from "./components/Loader/CircularLoader";
import OtherScreen from "./screens/other/other/OtherScreen";
import Rider from "./screens/rider/Rider";
import Settings from "./screens/Login/Settings";
import Users from "./screens/users/Users";
import Hospitals from "./screens/hospital/Hospitals";
import Pipeline from "./screens/hospital/Pipeline";
import Vendors from "./screens/vendor/Vendors";
import Cancelled from "./components/orders/cancelled/CancelledOrder";
import OngoingOrder from "./components/orders/ongoing/OngoingOrder";
import OverrideOrder from "./components/orders/override/OverrideOrder";
import PricingIssue from "./components/orders/pricing/getPricingData";
import Completed from "./components/orders/completed/CompletedOrder";
import Overdue from "./components/orders/overdue/OverdueOrder";
import Tickets from "./screens/ticket/Tickets";
import "./index.css";
import Cylinders from "./screens/cylinder/Cylinders";
import Series from "./screens/cylinder/Series";
import Batch from "./screens/cylinder/Batch.page";
import CylinderBatch from "./screens/cylinder/CylinderBatch";
import CylinderHospital from "./components/orders/ongoing/CylinderHospital";
import Notification from "./screens/notification/Notification";
import NerveClaims from "./screens/nerveClaims/NerveClaims";
import CradleRequest from "./screens/cradleRequest/CradleRequest";
import IncidentReport from "./screens/incidentReport/IncidentReport";
import NotifyNerve from "./screens/notifyNerve/NotifyNerve";
import CreateCohort from "./screens/createCohort/CreateCohort";
import AddHospital from "./screens/createCohort/AddHospital";
import CorhotMessage from "./screens/createCohort/CorhotMessage";
import QuotationDetail from "./screens/purchaseOrder/QuotationDetails";
import ConfirmUssdOrder from "./screens/Ussd/ConfirmUssdOrder";
import DeclineItem from "./components/ova/DeclineItem";
import StockItems from "./components/orderInstruction/StockItems";
import ProcessFailedItems from "./components/orderInstruction/ProcessFailedItems";
import ProcessStockBank from "./screens/placeOrder/processOrder/processStockBank";
import ProcessOrder from "./screens/placeOrder/processOrder/ProcessOrder";
import FailedItem from "./screens/failedBid/FailedItem";
import DeclinedQuotationItem from "./screens/declinedQuotations/DeclinedQuotationItem";
import ProcessDeclinedQuotation from "./components/orderInstruction/ProcessDeclinedQuotation";
import Returns from "./screens/return/Returns";
import ReturnList from "./screens/return/ReturnList";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDfIqc68hdrR_t0lC4ycOM0PQxegdiD6Tc",
  authDomain: "onebox-5a1c3.firebaseapp.com",
  projectId: "onebox-5a1c3",
  storageBucket: "onebox-5a1c3.appspot.com",
  messagingSenderId: "367791288128",
  appId: "1:367791288128:web:381719c233c1a29dd394a5",
  measurementId: "G-DZ2DRCNV8F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

const getTokenFunc = async () => {
  const messaging = getMessaging();
  getToken(messaging, {
    vapidKey: "BCsLnHXvtA2FZwh2BNyKvRzLvLL2QA2AngWCrp3JOy75mHrXDsvuS9TtAhOBNqdjhHjkjrya3a3KZi17HsHFKFg",
  })
    .then((currentToken) => {
      if (currentToken) {
        // console.log("token:", currentToken);
                const user = JSON.parse(localStorage.getItem("userDetails"));
        // console.log("user", user.data.id);

        if (user && user.data && user.data.id) {
          fetch("https://plus.lifebank.ng/lite/v2/api/admin/token", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: user.data.id,
              token: currentToken,
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              // console.log("Success:", data);
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        } else {
          console.log("User not found or user ID missing");
        }
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
    });
};

getTokenFunc();

function App() {
  return (
    <React.Fragment>
      <ErrorBoundary>
        <Suspense
          fallback={
            <div className="d-flex justify-content-center align-items-center min-vh-100">
              {/* Loading Please Wait... */}
              <CircularLoader />
            </div>
          }
        >
          <Provider store={store}>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={true}
            />
            <Router basename="/admin">
              <Routes>
                <Route path={`/login`} element={<LoginScreen />} />
                <Route>
                  <Route path={`/`} element={<Layout />}>
                    <Route path="ova" element={<DeclineItem />} />
                    <Route index element={<Dashboard />} />
                    <Route path={`/settings`} element={<Settings />} />
                    <Route path={`/cancelled`} element={<Cancelled />} />
                    <Route path={`/completed`} element={<Completed />} />
                    <Route path={`/overdue`} element={<Overdue />} />
                    <Route path="stockitem/:id" element={<StockItems />} />
                    <Route path="process-failed-item/:id" element={<ProcessFailedItems />} />
                    <Route path="declined-quotation" element={<DeclinedQuotationItem />} />
                    <Route path="process-declined-quotation/:id" element={<ProcessDeclinedQuotation />} />
                    <Route path={`/user`} element={<Users />} />
                    {/* <Route path={`/po`} element={<Po />} />
                    <Route path={`/podetails/:id`} element={<Podetails />} />
                    <Route path={`/see-quotation`} element={<Quotation />} /> */}
                    <Route
                      path={`/quotation-detail/:id`}
                      element={<QuotationDetail />}
                    />
                    <Route
                      path={`incident/report`}
                      element={<IncidentReport />}
                    />
                    <Route path={`/nerve-claims`} element={<NerveClaims />} />
                    <Route path={`/failed-bids`} element={<FailedItem />} />
                    <Route
                      path={`/crade/request`}
                      element={<CradleRequest />}
                    />
                    <Route
                      path="process-order/:id"
                      element={<ProcessOrder />}
                    />
                    <Route
                      path="processorder/:id"
                      element={<ProcessStockBank />}
                    />
                    <Route path={`/notify/nerve/`} element={<NotifyNerve />} />
                    <Route path={`/create-cohort`} element={<CreateCohort />} />
                    <Route
                      path={`/cohort-message`}
                      element={<CorhotMessage />}
                    />
                    <Route
                      path={`/add-hospital/:id`}
                      element={<AddHospital />}
                    />
                    <Route path={`/notifications`} element={<Notification />} />
                    <Route path={`/lifebank-hospitals`} element={<Hospitals />} />
                    <Route path={`/pipeline-hospitals`} element={<Pipeline />} />
                    <Route path={`/cylinders`}>
                      <Route index element={<Cylinders />} />
                      <Route path={`batches`} element={<CylinderBatch />} />
                      <Route path={`hospitals`} element={<CylinderHospital />} />
                      <Route path={`:id`} element={<Series />} />
                    </Route>
                    <Route path={`/codes`} element={<Batch />} />
                    <Route path={`/tickets`} element={<Tickets />} />
                    <Route path={`/returns`} element={<Returns />} />
                    <Route path={`/return-list`} element={<ReturnList />} />
                    {/* <Route path={`/inventory-upload`} element={<Inventory />} />
                    <Route path={`/inventory-upload/upload/:id`} element={<Upload />} /> */}
                    <Route path={`/vendors`} element={<Vendors />} />
                    <Route path={`/ongoing`} element={<OngoingOrder />} />
                    <Route path={`/override`} element={<OverrideOrder />} />
                    <Route path={`pricing`} element={<PricingIssue />} />
                    <Route path={`/riders`} element={<Rider />} />
                    {/* <Route path={`/ussd-product`} element={<Ussd />} /> */}
                     <Route
                      path={`/confirm-ussd`}
                      element={<ConfirmUssdOrder />}
                    />
                    <Route path={`/track-order/:id`} element={<Track />} />
                    <Route path={`/*`} element={<OtherScreen />} />
                  </Route>
                </Route>
              </Routes>
            </Router>
          </Provider>
        </Suspense>
      </ErrorBoundary>
    </React.Fragment>
  );
}

export default App;
